import './App.css';
import InputListener from './InputListener';

function App() {
	return (
		<div className="App d-flex flex-column justify-content-center align-items-center my-5 vh-100">
			<InputListener />
		</div>
	);
}

export default App;
